module.exports = __webpack_public_path__ + "img/vascular-750.bb28362b.jpg";